/* istanbul ignore next */
const fetchAI = async (generativeAIApiUrl, paragraph) => {
  const payload = {
    intentSchemaId: 'grammar_spelling_intent_schema.json',
    contextList: [{
      type: 'ADF_MARKDOWN_V1',
      entity: paragraph,
      relationship: 'SELECTION'
    }],
    modelPlatform: 'OPENAI',
    outputLocale: 'en-US',
    streaming: false,
    outputFormat: {
      outputFormatType: 'MARKDOWN',
      markdowns: ['PARAGRAPH', 'BULLET_LISTS', 'NUMBERED_LISTS', 'HEADING', 'BLOCKQUOTES', 'CODEBLOCKS', 'LINK', 'ITALICS', 'BOLD', 'STRIKETHROUGH', 'CODE_SPAN']
    },
    product: 'CONFLUENCE'
  };
  const abortController = new AbortController();
  const fetchInit = {
    method: 'POST',
    // When we move to a single api endpoint we will be able to collapse
    // the current logic spread across;
    // - api-fetch
    // - generate, transform, summarise
    // - mapResponseForSingleKeyToMarkdown
    // - and various config items
    // In the meantime -- have opted into this stringify -> parse -> stringify
    // to keep the shapes of startStreamingResponse and startSingleResponse aligned.
    body: JSON.stringify(payload),
    credentials: 'include',
    signal: abortController.signal,
    mode: 'cors'
  };
  const response = await fetch(generativeAIApiUrl, {
    ...fetchInit,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-Experience-Id': 'editor'
    }
  });
  return response.json();
};

// HACK: This is an internal cache purely to avoid rate limiting and hitting the endpoint mulitple times with the same text.
// This is not good and can result in a mem leak so we should not ship this
const paragraphCache = new Map();

/* istanbul ignore next */
export const fetchAIParagraphs = async (generativeAIApiUrl, paragraphs) => {
  const missingParagraphs = paragraphs.filter(({
    text
  }) => !paragraphCache.has(text));
  const promises = await Promise.allSettled(missingParagraphs.map(async ({
    text
  }) => {
    const response = await fetchAI(generativeAIApiUrl, text);
    if (!!(response !== null && response !== void 0 && response.generatedContent) && paragraphCache.size < 1000) {
      paragraphCache.set(text, response === null || response === void 0 ? void 0 : response.generatedContent);
    }
    return response === null || response === void 0 ? void 0 : response.generatedContent;
  }));

  // converts the cached paragraphs into a something resembling a settled promise result
  // We need to ensure the order of the returned result is parrallel to the input
  const result = paragraphs.map(({
    text
  }, index) => {
    var _paragraphCache$get, _promises$index;
    return {
      status: 'fulfilled',
      value: (_paragraphCache$get = paragraphCache.get(text)) !== null && _paragraphCache$get !== void 0 ? _paragraphCache$get : (_promises$index = promises[index]) === null || _promises$index === void 0 ? void 0 : _promises$index.value
    };
  });
  return result;
};